module.exports = __webpack_public_path__ + "static/media/icon_to_close_sidebar.af4b6555.svg";